import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useCallback, useEffect } from 'react';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { useAttachmentStoreActions, useAttachmentStoreDeletableCount, useAttachmentStoreError, useAttachmentStoreIsFetching, useAttachmentStoreOrderDirection, useAttachmentStoreOrderField, useAttachmentStoreStartAt, useAttachmentStoreTotalCount, useAttachmentStoreVisibleAttachments } from './context';
export var useIssueAttachmentsActions = function useIssueAttachmentsActions() {
  var _useAttachmentStoreAc = useAttachmentStoreActions(),
    _useAttachmentStoreAc2 = _slicedToArray(_useAttachmentStoreAc, 2),
    actions = _useAttachmentStoreAc2[1];
  var _useAnalyticsEvents = useAnalyticsEvents(),
    createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
  var setOrderDirection = actions.setOrderDirection,
    setOrderField = actions.setOrderField,
    setTotalCount = actions.setTotalCount,
    setDeletableCount = actions.setDeletableCount,
    setVisibleAttachments = actions.setVisibleAttachments,
    addNewAttachments = actions.addNewAttachments,
    storeDeleteAttachment = actions.deleteAttachment,
    getAttachments = actions.getAttachments,
    refreshAttachments = actions.refreshAttachments;
  var deleteAttachment = useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(issueAttachmentKey, deletingAttachmentId, fetchOptions) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return storeDeleteAttachment(issueAttachmentKey, deletingAttachmentId, createAnalyticsEvent, fetchOptions);
          case 3:
            _context.next = 7;
            break;
          case 5:
            _context.prev = 5;
            _context.t0 = _context["catch"](0);
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 5]]);
    }));
    return function (_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }(), [createAnalyticsEvent, storeDeleteAttachment]);
  return [null, {
    setOrderDirection: setOrderDirection,
    setOrderField: setOrderField,
    setTotalCount: setTotalCount,
    setDeletableCount: setDeletableCount,
    setVisibleAttachments: setVisibleAttachments,
    addNewAttachments: addNewAttachments,
    getAttachments: getAttachments,
    deleteAttachment: deleteAttachment,
    refreshAttachments: refreshAttachments
  }];
};
export var useIssueAttachments = function useIssueAttachments(issueKey, options) {
  var _useIssueAttachmentsA = useIssueAttachmentsActions(),
    _useIssueAttachmentsA2 = _slicedToArray(_useIssueAttachmentsA, 2),
    actions = _useIssueAttachmentsA2[1];
  var _useAttachmentStoreIs = useAttachmentStoreIsFetching(issueKey),
    _useAttachmentStoreIs2 = _slicedToArray(_useAttachmentStoreIs, 1),
    isFetching = _useAttachmentStoreIs2[0];
  var _useAttachmentStoreEr = useAttachmentStoreError(issueKey),
    _useAttachmentStoreEr2 = _slicedToArray(_useAttachmentStoreEr, 1),
    error = _useAttachmentStoreEr2[0];
  var _useAttachmentStoreOr = useAttachmentStoreOrderDirection(),
    _useAttachmentStoreOr2 = _slicedToArray(_useAttachmentStoreOr, 1),
    orderDirection = _useAttachmentStoreOr2[0];
  var _useAttachmentStoreOr3 = useAttachmentStoreOrderField(),
    _useAttachmentStoreOr4 = _slicedToArray(_useAttachmentStoreOr3, 1),
    orderField = _useAttachmentStoreOr4[0];
  var _useAttachmentStoreSt = useAttachmentStoreStartAt(),
    _useAttachmentStoreSt2 = _slicedToArray(_useAttachmentStoreSt, 1),
    startAt = _useAttachmentStoreSt2[0];
  var _useAttachmentStoreTo = useAttachmentStoreTotalCount(issueKey),
    _useAttachmentStoreTo2 = _slicedToArray(_useAttachmentStoreTo, 1),
    totalCount = _useAttachmentStoreTo2[0];
  var _useAttachmentStoreDe = useAttachmentStoreDeletableCount(issueKey),
    _useAttachmentStoreDe2 = _slicedToArray(_useAttachmentStoreDe, 1),
    deletableCount = _useAttachmentStoreDe2[0];
  var _useAttachmentStoreVi = useAttachmentStoreVisibleAttachments(issueKey),
    _useAttachmentStoreVi2 = _slicedToArray(_useAttachmentStoreVi, 1),
    visibleAttachments = _useAttachmentStoreVi2[0];
  var _useAnalyticsEvents2 = useAnalyticsEvents(),
    createAnalyticsEvent = _useAnalyticsEvents2.createAnalyticsEvent;
  var getAttachments = actions.getAttachments;
  useEffect(function () {
    if (totalCount === undefined && !isFetching && !error) {
      getAttachments(issueKey, createAnalyticsEvent, options);
    }
  }, [createAnalyticsEvent, error, getAttachments, issueKey, isFetching, options, totalCount]);
  var meta = {
    orderDirection: orderDirection,
    orderField: orderField,
    startAt: startAt
  };
  var value = {
    attachments: visibleAttachments,
    totalCount: totalCount || 0,
    deletableCount: deletableCount || 0
  };
  return [{
    error: error,
    meta: meta,
    value: value,
    loading: isFetching
  }, actions];
};
export var useViewMediaClientConfig = function useViewMediaClientConfig(viewContext) {
  if (viewContext) {
    return {
      authProvider: function authProvider() {
        return Promise.resolve({
          baseUrl: viewContext.serviceHost || '',
          clientId: viewContext.clientId || '',
          token: viewContext.token || ''
        });
      },
      useSha256ForUploads: true
    };
  } else {
    return null;
  }
};